import * as React from 'react';
import { css, html } from 'react-strict-dom';
import { color } from 'src/constants/color.css';

import { Text } from '../../../components';
import { Style } from '../../../constants';

const GITHUB_USERNAMES: Record<string, string> = {
  jamesisaac: 'james_isaac',
  'kwhui-m10c': 'ka-wai_hui',
  markm10c: 'mark_mansour',
  shahzaibm10c: 'shahzaib_tariq',
  sonjabrehm: 'sonja_brehm',
  timbm10c: 'tim_bartrum',
  viktorijagrigaite: 'viktorija_isaac',
  'wei-m10c': 'wei_cheng',
};

function initials(name: string) {
  const parts = name.trim().split(/\s+/);
  return ((parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? '')).toUpperCase();
}

type Props = {
  author: string;
  size?: number;
};

export default function CommitAuthorAvatar({ author, size = 20 }: Props) {
  const [imgError, setImgError] = React.useState(false);
  const avatarFile = GITHUB_USERNAMES[author.toLowerCase()];
  return (
    <html.div style={[Style.centerBoth, styles.avatar(size)]}>
      {avatarFile && !imgError ? (
        <html.img
          src={`/img/avatars/${avatarFile}.jpg`}
          alt={author}
          style={styles.img}
          onError={() => setImgError(true)}
        />
      ) : (
        <Text style={styles.initials}>{initials(author)}</Text>
      )}
    </html.div>
  );
}

const styles = css.create({
  avatar: (size: number) => ({
    width: size,
    height: size,
    borderRadius: 100,
    backgroundColor: color.neutral100,
    overflow: 'hidden',
  }),
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  initials: {
    fontSize: 10,
    fontWeight: '600',
    color: color.neutral0,
  },
});
